// Display labels for inbound calls forwarded in from a native phone-system
// integration. Only providers with an explicit label render a badge on voice
// and activity surfaces; everything else returns null (no badge).
const EXTERNAL_FORWARDING_PROVIDER_LABELS: Record<string, string> = {
    ringcentral: 'RingCentral',
    goto: 'GoTo',
};

export function externalForwardingProviderBadgeLabel(
    provider: string | null | undefined,
): string | null {
    if (!provider) {
        return null;
    }
    return EXTERNAL_FORWARDING_PROVIDER_LABELS[provider.toLowerCase()] ?? null;
}
